import type { IIconProps } from '@app/components/Icon/types'
import { PldIcon } from '@tenable/paladin'
import type React from 'react'

interface IIconAlertTulProps extends IIconProps {}

const IconAlertTul: React.FC<IIconAlertTulProps> = props => {
  return (
    <tenable-floating-button
      id="notifications-menu-button"
      aria-label="Notifications"
      aria-haspopup="true"
    >
      <PldIcon icon="IconBell" size="iconSizeM" color="colorTextPrimary" />
    </tenable-floating-button>
  )
}

export default IconAlertTul
